// src/config/features.ts
// Deploy-scope feature switches (build-time constants, not per-user flags).

/** Tester deploy runs with NO data retention: the persistence UI (Save / Share link /
 *  Save & Share — Firestore + Storage writes via saveGeneratedRoast) is hidden everywhere
 *  and the player warns before leaving without a downloaded video. Flip to true to restore
 *  persistence; the saved-path tests are it.skip'd with references to this flag. */
export const PERSISTENCE_ENABLED: boolean = false;
